// @todo use the util currency helper
export default (function (userLocale) {
    switch (userLocale) {
        case "fr-FR":
            return "EUR";
        case "en-AU":
            return "AUD";
        case "en-GB":
        default:
            return "GBP";
    }
});
